import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import debounce from 'lodash/debounce';
import dataService from 'services/dataService';
import List from 'components/atoms/list';
import classNames from 'classnames';
import useOutsideClick from 'utils/useOutsideClick';
import DropdownLensIcon from 'components/atoms/icons/dropdownLensIcon';
import { ccmPageAvailableStatuses } from 'constants/patient_statuses';
import { apiUrlGenerator } from 'utils/useTable';

const loadingOptions = [{ id: 'loading', label: 'Loading...' }];
let timer;

const PatientAutocomplete = ({
  filter,
  handleClick,
  patient,
  dropDownIcon,
}) => {
  const [query, setQuery] = useState('');
  const ref = useRef();
  const [show, setShow] = useState(false);
  const [options, setOptions] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useOutsideClick(ref, () => {
    setQuery('');
    setShow(false);
  });

  const handleOptionClick = (option) => {
    setQuery('');
    setShow(false);
    return handleClick(option);
  };

  const generateFilterLabel = (item) =>
    `${item.firstName} ${item.lastName} - ${item.birthDate}`;

  const debouncedSearch = debounce(async (string) => {
    const filteredString = string.replace('+', '%2B');
    const ccmStatus = ccmPageAvailableStatuses.join(',');
    const { id } = filter;
    const url = 'core/patients';
    const items = 100;
    const page = 1;
    const filters = {
      [`${id}`]: filteredString,
      patientRequestType: 'search',
      status: 'all',
      ccmStatus,
    };
    const { data } = await dataService.getList(
      apiUrlGenerator(url, items, page, filters),
    );
    setIsLoading(false);
    if (data) {
      setOptions(
        data.items.map((item) => ({
          id: item.guid,
          value: item.guid,
          label: generateFilterLabel(item),
        })),
      );
    }
  }, 800);

  const handleInputChange = (string) => {
    if (string.target) {
      setQuery(string.target.value);
    }
    setIsLoading(true);
    clearTimeout(timer);
    timer = setTimeout(() => {
      debouncedSearch(string.target ? string.target.value : query);
    }, 500);
  };

  const handleFocus = () => {
    if (filter.id === 'fullName') {
      setQuery('');
      handleInputChange('');
      setShow(true);
    }
  };

  return (
    <div
      className="ccm-patient-filter-autocomplete"
      ref={ref}
      onClick={handleFocus}
    >
      <div className="dropdown-bordered" role="button" aria-hidden>
        <div
          className={classNames({
            'card-body-sort': !patient,
          })}
        >
          <p>Search</p>
          <div className="dropdown-bordered__body">
            <input
              className={dropDownIcon ? 'arrow' : ''}
              type="text"
              onChange={handleInputChange}
              value={query}
            />
            {dropDownIcon && <DropdownLensIcon />}
          </div>
        </div>
      </div>
      {((query.length > 0 && isLoading) || (show && isLoading)) && (
        <div className="patient-filter-dropdown-body">
          <List onChange={() => {}} options={loadingOptions} />
        </div>
      )}
      {((query.length > 0 && !isLoading && options && options.length > 0) ||
        (!isLoading && options && options.length > 0 && show)) && (
        <div className="patient-filter-dropdown-body">
          <List onChange={handleOptionClick} options={options} />
        </div>
      )}
    </div>
  );
};

PatientAutocomplete.propTypes = {
  filter: PropTypes.shape().isRequired,
  handleClick: PropTypes.func.isRequired,
  patient: PropTypes.bool,
  dropDownIcon: PropTypes.bool,
};

export default PatientAutocomplete;
